<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <form class="form-horizontal" style="padding-top:10px" id="bs_form">
						<div class="col-sm-4">
						    <div class="form-group">
						        <label class="col-sm-3 control-label">关键字</label>
						        <div class="col-sm-9">
						            <input type="text"  v-model="query.word" name="keyword" class="form-control" placeholder="">
						        </div>
						    </div>
						</div>
						<div class="col-sm-3">
						        <button @click="search()" type="button" class="btn btn-primary btn-sm"><i class="fa fa-search" aria-hidden="true"></i>查询</button>
						          <button @click="addPc()" type="button" class="btn btn-primary btn-sm" style="margin-left: 15px;"><i class="fa fa-plus" aria-hidden="true"></i>新增批次</button> 
						</div>
                </form>
            </div>
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:true,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
                                    @onPageChange="pageChange"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
		
		<YearBatchAdd ref="YearBatchAdd"></YearBatchAdd>
		<YearBatchEdit ref="YearBatchEdit"></YearBatchEdit> 
    </div>
</template>
<script>
    import tableMixin from '@/mixins/table.js';
    import YearBatchAdd from './YearBatchAdd.vue'; 
    import YearBatchEdit from './YearBatchEdit.vue';
    import {xllx_map} from '@/plugins/enums.js';
    export default {
        mixins: [tableMixin],
        name:"YearBatchList",
		components: {
			YearBatchAdd,
			YearBatchEdit 
		},
        data:function(){
            return {
                query:{
					word:''
                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                            var options = this.$refs.table.getOptions();
                            return options.pageSize * (options.pageNumber - 1) + index + 1;
                        }
                    },
					{
                        field: 'mc',
                        title: '批次名称'
                    },
					{
					    field: 'lx',
					    title: '学历类型',
						formatter: (value, row, index)=> {
							return xllx_map[value];
						}
					},
                    {
                        field: 'zt',
                        title: '状态',
                        formatter: (value) => {
                            return value == 'OK' ? '开放' : '关闭';
                        }
                    },
                    {
                        field: 'actions',
                        title: '操作',
                        align: 'center',
                        width:'230px',
                        formatter: (value, row) => {
                            let btnName=row.zt=='OK' ? '禁用' :'启用';
                            return this.vueFormatter({
                                template: '<div data-id="'+row.id+'" class="operation_column">' +
                                    '<a @click="edit(row)">修改</a> | <a @click="qtit(row)">'+btnName+'</a></div>',
                                data: { row },
                                methods: {
                                    edit: this.edit,
                                    qtit: this.qtit
                                }
                            })
                        }
                    }
                ]
            }
        },
		mounted(){
			this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
			this.load();
		},
		beforeRouteUpdate(to, from, next){
			this.query = Object.assign(this.query,{current:1,size:10},to.query);
			this.load();
			next();
		},
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'基础数据'},{name:'基础信息查询'}, {name:'注册批次管理'}]);
		},
        methods: {
			showbmQrCode:function(row){
				this.$refs.ZyjdPcBmQrCode.open({mc:row.mc,
							id:row.id,
							bmUrl:row.bmUrl});
			},
            addPc:function(){
				this.$refs.YearBatchAdd.open();
            },
            edit:function (row) {
				this.$refs.YearBatchEdit.open({id:row.id});
            },
            //启用/禁用提示
            qtit:function (row) {
                let id= row.id;
                let zt = row.zt=='OK' ? 'BLOCK' : 'OK';
				this.$confirm('确定执行此操作吗？',()=>{
					this.$http.post("/htgl/inf/zcpc/enable",{id:id, zt:zt}).then((res)=>{
					    if(res.data==true){
							this.$success('操作成功',()=>{
								this.load();//刷新列表
							});
					    }
					});
				});
            },
          search:function(){
              //将数据表格的页码以及每一页展示的数据重置为1，10
          	let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
          	this.$router.push({name:this.$route.name,query:query});
          },
            //返回表格数据
            load:function(pageNumber, pageSize){
                this.query.current = pageNumber || this.query.current;
                this.query.size = pageSize || this.query.size;
                this.$http.post('/htgl/inf/zcpc/cx',this.query).then(res=>{  
                    let data = res.data;
                    //封装返回值
                    let result= {
                        total: data.total,
                        rows: data.records
                    };
                    //table加载返回的数据
                    this.$refs.table.load(result);
					this.$refs.table.refreshOptions({pageNumber:parseInt(this.query.current),
						pageSize:parseInt(this.query.size)});
                });
            },
           pageChange:function(pageNumber, pageSize){
           	let query = Object.assign(this.query,{current:pageNumber,size:pageSize},{_t:new Date().getTime()});
           	this.$router.push({name:this.$route.name,query:query});
           }
        }

    }
</script>
<style scoped>

</style>
